(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  function init(root = document) {
    if (motion.matches || !('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('vv-in-view'); observer.unobserve(entry.target); }
    }), { threshold: 0.06 });
    root.querySelectorAll('.vv-path,.mp-product-card,.vv-about__art,.vv-about__copy,.mp-split,.mp-feature-card,.mp-blog-card,.mp-review-card,.mp-image-panel,.mp-product-media,.mp-article-image').forEach((el, i) => {
      if (el.classList.contains('vv-reveal-ready') || el.getBoundingClientRect().top < window.innerHeight) return;
      el.style.setProperty('--vv-delay', `${(i % 3) * 70}ms`);
      el.classList.add('vv-reveal-ready'); observer.observe(el);
    });
  }
  motion.addEventListener('change', () => {
    observer?.disconnect(); observer = null;
    document.querySelectorAll('.vv-reveal-ready').forEach(el => el.classList.remove('vv-reveal-ready','vv-in-view'));
    init();
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('focusin', event => event.target.closest('.vv-reveal-ready')?.classList.add('vv-in-view'));

  function livingWater(root = document) {
    root.querySelectorAll('.vv-hero--v2').forEach(hero => {
      const canvas = hero.querySelector('.vv-hero__water-canvas');
      const image = hero.querySelector('.vv-hero__backdrop');
      if (!canvas || canvas.dataset.ready) return;
      canvas.dataset.ready = 'true';
      const context = canvas.getContext('2d');
      let frame = 0;
      const render = time => {
        const box = hero.getBoundingClientRect();
        const ratio = Math.min(window.devicePixelRatio || 1, 1.5);
        const width = Math.max(1, Math.round(box.width * ratio));
        const height = Math.max(1, Math.round(box.height * ratio));
        if (canvas.width !== width || canvas.height !== height) { canvas.width = width; canvas.height = height; }
        context.clearRect(0, 0, width, height);
        if (image.complete && image.naturalWidth && !motion.matches) {
          const scale = Math.max(width / image.naturalWidth, height / image.naturalHeight);
          const drawWidth = image.naturalWidth * scale;
          const drawHeight = image.naturalHeight * scale;
          const offsetX = (width - drawWidth) / 2;
          const offsetY = (height - drawHeight) / 2;
          const waterTop = Math.round(height * .54);
          context.save();
          context.beginPath();
          context.moveTo(0, waterTop);
          context.lineTo(width, waterTop);
          context.lineTo(width, height * .67);
          context.lineTo(width * .74, height * .67);
          context.lineTo(width * .74, height * .76);
          context.lineTo(width * .58, height * .76);
          context.lineTo(width * .58, height * .90);
          context.lineTo(0, height * .90);
          context.closePath();
          context.clip();
          const strip = Math.max(2, Math.round(3 * ratio));
          context.globalAlpha = .92;
          for (let y = waterTop; y < height; y += strip) {
            const depth = (y - waterTop) / Math.max(1, height - waterTop);
            const wave = Math.sin(y * .075 + time * .0015) * (2 + depth * 7) * ratio;
            const swell = Math.sin(y * .024 - time * .0008) * (1 + depth * 3) * ratio;
            context.drawImage(image, 0, (y - offsetY) / scale, image.naturalWidth, strip / scale + 1, offsetX + wave + swell, y, drawWidth, strip + 1);
          }
          const light = context.createLinearGradient(width*.58,0,width*.72,0);
          light.addColorStop(0,'rgba(255,220,151,0)'); light.addColorStop(.5,'rgba(255,220,151,.10)'); light.addColorStop(1,'rgba(255,220,151,0)');
          context.globalCompositeOperation='screen'; context.fillStyle=light; context.fillRect(0,waterTop,width,height-waterTop); context.globalCompositeOperation='source-over';
          context.restore();
        }
        frame = requestAnimationFrame(render);
      };
      const start = () => { if (!frame) frame=requestAnimationFrame(render); };
      image.complete ? start() : image.addEventListener('load',start,{once:true});
    });
  }
  function decorate(root = document) {
    livingWater(root);
    root.querySelectorAll('.vv-hero__sparkles span').forEach((el,i) => {el.style.setProperty('--i',i);el.style.setProperty('--j',(i*7)%9);});
    root.querySelectorAll('[data-vv-motion-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true'; button.hidden = motion.matches;
      button.addEventListener('click', () => {
        const paused = document.body.classList.toggle('vv-motion-paused');
        button.setAttribute('aria-pressed', String(paused)); button.textContent = paused ? 'Play animation' : 'Pause animation';
      });
      motion.addEventListener('change', () => {button.hidden = motion.matches;});
    });
  }
  document.addEventListener('shopify:section:load', event => decorate(event.target));
  decorate(); init();
})();
